// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7078) return "static/chunks/87199af8-7d449487ca4bef67.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"857":"0414891f9325a20d","6866":"df23c38bc52a9a36","7823":"07ea29e43f666b32","8777":"bdb4b157217b5969"}[chunkId] + ".js";
};